import { Button } from "@/shared/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu";
import { Eye } from "lucide-react";
import { Tooltip } from "@/shared/ui/tooltip";
import type { VisibilityState } from "@tanstack/react-table";
import type { ReactNode } from "react";

interface ColumnConfig {
  id: string;
  label: string;
}

interface TableToolbarProps {
  columnVisibility: VisibilityState;
  onColumnVisibilityChange: (visibility: VisibilityState) => void;
  columns: readonly ColumnConfig[];
  leftActions?: ReactNode;
  actions?: ReactNode;
}

export function TableToolbar({
  columnVisibility,
  onColumnVisibilityChange,
  columns,
  leftActions,
  actions,
}: TableToolbarProps) {
  return (
    <div className="grid grid-cols-3 items-center border-b border-grid-200 bg-white px-4 py-2 shrink-0 gap-2">
      <div className="flex items-center gap-2 justify-start">{leftActions}</div>

      <div className="flex items-center gap-2 justify-center">
        <Tooltip content="Column Visibility">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                size="sm"
                aria-label="Column Visibility"
                className="gap-2"
              >
                <Eye className="h-4 w-4" />
                Columns
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              align="start"
              className="w-56 max-h-96 overflow-y-auto"
            >
              <DropdownMenuLabel>Toggle Columns</DropdownMenuLabel>
              <DropdownMenuSeparator />
              {columns.map((column) => (
                <DropdownMenuCheckboxItem
                  key={column.id}
                  checked={columnVisibility[column.id] !== false}
                  onCheckedChange={(checked) =>
                    onColumnVisibilityChange({
                      ...columnVisibility,
                      [column.id]: checked,
                    })
                  }
                >
                  {column.label}
                </DropdownMenuCheckboxItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </Tooltip>
        {actions}
      </div>
      <div />
    </div>
  );
}
